import type {
  ExtractedFileData,
  TransformResult,
  ParsedFileData,
} from "../types";
import { transformNotification } from "./notificationTransformer";
import { transformImpact } from "./impactTransformer";
import { transformNotificationDecision } from "./notificationDecisionTransformer";
import { transformRiskAnalysis } from "./riskAnalysisTransformer";

export function transformExtracted(
  extracted: ExtractedFileData,
  parsedFile?: ParsedFileData
): TransformResult {
  switch (extracted.documentType) {
    case "notification":
      return {
        documentType: "notification",
        data: transformNotification(extracted),
      };
    case "impact":
      return { documentType: "impact", data: transformImpact(extracted) };
    case "notification_decision":
      return {
        documentType: "notification_decision",
        data: transformNotificationDecision(extracted),
      };
    case "risk_analysis":
      return {
        documentType: "risk_analysis",
        data: transformRiskAnalysis(extracted, parsedFile),
      };
  }
}

export { transformNotification } from "./notificationTransformer";
export { transformImpact } from "./impactTransformer";
export { transformNotificationDecision } from "./notificationDecisionTransformer";
export { transformRiskAnalysis } from "./riskAnalysisTransformer";
